import React from "react";

export default function JuridicoForm() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-80px)] bg-white text-black px-4 pt-20">
      {/* Ícone de construção */}
      <div className="mb-8 animate-bounce">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-20 w-20 text-black"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={1.5}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13 16h-1v-4h-1m4 0h-1a1 1 0 00-1-1h-1v-2a1 1 0 00-1-1h-1v6h1v4h-1m8-2a2 2 0 11-4 0 2 2 0 014 0z"
          />
        </svg>
      </div>

      {/* Texto principal */}
      <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center">
        Página em Construção
      </h1>

      {/* Subtexto */}
      <p className="text-lg md:text-xl text-gray-700 text-center max-w-md">
        Estamos trabalhando para entregar a melhor experiência para você. Volte
        em breve!
      </p>
    </div>
  );
}
